const teamSliders = async function( $block ) {
	const { Swiper } = await import( "swiper" );
	await import( "swiper/css/bundle" );
	const { Navigation, Controller, Pagination } = await import( "swiper/modules" );

	const $sliderFirst = $block.find( ".team__slider" );
	const $sliderSecond = $block.find( ".team__slider--second" );

	if ( !$sliderFirst.length || !$sliderSecond.length ) {
		return false;
	}

	const teamSliderSecond = new Swiper( $sliderSecond[0], {
		modules: [Navigation, Controller, Pagination],
		slidesPerView: 2,
		spaceBetween: 20,
		speed: 1000,
		loop: true,
		simulateTouch: false,
	} );

	teamSliderSecond.init();

	const teamSlider = new Swiper( $sliderFirst[0], {
		modules: [Navigation, Controller, Pagination],
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 1000,
		loop: true,
		simulateTouch: false,
		navigation: {
			prevEl: ".team__prev",
			nextEl: ".team__next",
		},
		pagination: {
			el: ".team__pagination",
			type: "bullets",
			clickable: true,
		},
		breakpoints: {
			1199: {slidesPerView: 2},
			940: {slidesPerView: 3},
			600: {slidesPerView: 2},
		},
	} );

	teamSlider.init();

	teamSlider.controller.control = teamSliderSecond;

	teamSliderSecond.controller.control = teamSlider;
};
 
themeUtils.loadBlock( teamSliders, "team", ".team" );